export const step1intro = {
    id: 1,
    title: 'Úvod do hry',
    taskText: `
        <p>
            Přejeme hodně štěstí během naší Šifrovací hry!
        </p>
        <p>   
            Polovina úkolů, které budete řešit, budou přímo v naší aplikaci a zbytek se bude týkat konkrétních míst, 
            na kterých se budete nacházet. Vše je ale připraveno tak, abyste při řešení úkolů nemuseli chodit dál než 50 
            metrů od místa, kde úkol získáte. Mimo jiné bude občas ve hře i možnost, kdy pouze odkliknete, 
            že jste už dorazili na dané místo, aby hra mohla pokračovat.
        </p>
        <p>
            Za každý splněný úkol obdržíte <b>10 penízků</b>. Kvůli opravdu nízké náročnosti úkolů jsme nezařadili 
            nápovědy. Dáváme vám ale možnost zobrazit si řešení úkolů a to bez jakékoliv penalizace, 
            pouze bez bodového zisku. 
        </p>
        <p>
            Pokud si jako rodič nebudete jistý odpovědí, můžete kliknout na tlačítko "Pro rodiče", kde uvidíte, co všechno 
            už jste se během hry dozvěděli.
        </p>
        <p>
            Chtěli bychom vás také poprosit, abyste na sebe byli <b>opatrní</b> a dávali pozor na auta. 
            Některá z míst jsou poblíž silnice, přecházejte tedy opatrně.
        </p>
<!--        <p>-->
<!--            U některých textů uvidíte toto tlačítko: *playIcon* <br />Po jeho stlačení si můžete <b>přehrát zvukovou nahrávku</b> daného textu. -->
<!--        </p>-->
        <p>
            Teď už tedy víte vše potřebné a užijte si hru!  
        </p>

    `,
    continueButtonText: 'Začít hru',
    points: false,
};
